import { ApiService } from "./api.service";
import { environment as ENV } from "../../../environments/environment";


export class FileServerService extends ApiService { 
    protected _apiUrl: string = ENV.fileServerLink;
}